import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataContainer } from 'components/DataContainer';
import { BlackButton, Flex, MarginBox, Spin } from 'UI';
import { LOADING, SEARCH_STATUS } from 'utils';

const ClaimFormSubmitButton = ({
  claimStatus,
  isClaimFormValid,
}: {
  claimStatus: SEARCH_STATUS;
  isClaimFormValid: boolean;
}) => {
  const { t } = useTranslation();
  const isLoading = claimStatus === LOADING;

  return (
    <Flex minHeight={60} align={'flex-end'}>
      <DataContainer
        data={claimStatus}
        Loading={() => (
          <MarginBox ml={20}>
            <Spin />
          </MarginBox>
        )}
        Skeleton={() => (
          <BlackButton htmlType={'submit'} disabled={!isClaimFormValid || isLoading}>
            {t('common.action.send', 'Send')}
          </BlackButton>
        )}
      />
    </Flex>
  );
};

export default ClaimFormSubmitButton;
